const verses = [
  {
    english: { text: "For God so loved the world that He gave His one and only Son, that whoever believes in Him shall not perish but have eternal life.", ref: "John 3:16" },
    tamil: { text: "தேவன், தம்முடைய ஒரேபேறான குமாரனை விசுவாசிக்கிறவன் எவனும் கெட்டுப்போகாமல் நித்தியஜீவனை அடையும்படிக்கு, அவரை தந்தருளி உலகத்தில் அன்பாயிருந்தார்.", ref: "யோவான் 3:16" },
    malayalam: { text: "തന്റെ ഏകജാതനായ പുത്രനിൽ വിശ്വസിക്കുന്ന ഏവനും നശിച്ചുപോകാതെ നിത്യജീവൻ പ്രാപിക്കേണ്ടതിന്നു ദൈവം അവനെ നൽകുവാൻ തക്കവണ്ണം ലോകത്തെ സ്നേഹിച്ചു.", ref: "യോഹന്നാൻ 3:16" }
  },
  {
    english: { text: "I can do all this through Him who gives me strength.", ref: "Philippians 4:13" },
    tamil: { text: "என்னை பலப்படுத்துகிற கிறிஸ்துவினால் எல்லாவற்றையும் செய்யக்கூடும்.", ref: "பிலிப்பியர் 4:13" },
    malayalam: { text: "എന്നെ ശക്തനാക്കുന്നവൻ മുഖാന്തരം എനിക്ക് എല്ലാം ആകും.", ref: "ഫിലിപ്പ്യർ 4:13" }
  },
  {
    english: { text: "The Lord is my shepherd; I shall not want.", ref: "Psalm 23:1" },
    tamil: { text: "கர்த்தர் என் மேய்ப்பர்; எனக்கு குறைவுண்டாகாது.", ref: "சங்கீதம் 23:1" },
    malayalam: { text: "യഹോവ എന്റെ ഇടയൻ; എനിക്ക് മുട്ടുണ്ടാകയില്ല.", ref: "സങ്കീർത്തനം 23:1" }
  },
  {
    english: { text: "Trust in the Lord with all your heart and lean not on your own understanding.", ref: "Proverbs 3:5" },
    tamil: { text: "உன் முழு இருதயத்தோடும் கர்த்தரில் நம்பிக்கைவை; உன் சொந்த புத்தியை நம்பாதே.", ref: "நீதிமொழிகள் 3:5" },
    malayalam: { text: "പൂർണ്ണഹൃദയത്തോടെ യഹോവയിൽ ആശ്രയിക്ക; സ്വന്ത ബുദ്ധിയിൽ ഊന്നരുത്.", ref: "സദൃശ്യവാക്യങ്ങൾ 3:5" }
  },
  {
    english: { text: "Be strong and courageous. Do not be afraid; do not be discouraged, for the Lord your God will be with you wherever you go.", ref: "Joshua 1:9" },
    tamil: { text: "நீ திடமனதாயிருந்து தைரியமாயிரு; கர்த்தராகிய உன் தேவன் நீ போகும் இடங்களிலெல்லாம் உன்னோடிருக்கிறார்.", ref: "யோசுவா 1:9" },
    malayalam: { text: "ശക്തനും ധൈര്യശാലിയും ആയിരിക്ക; ഭ്രമിക്കരുത്, ഭയപ്പെടരുത്; നിന്റെ ദൈവമായ യഹോവ നീ പോകുന്നിടത്തൊക്കെ നിന്നോടുകൂടെ ഉണ്ട്.", ref: "യോശുവ 1:9" }
  },
  {
    english: { text: "And we know that in all things God works for the good of those who love Him.", ref: "Romans 8:28" },
    tamil: { text: "தேவனிடத்தில் அன்பாயிருக்கிறவர்களுக்கு, அதாவது அவருடைய தீர்மானத்தின்படி அழைக்கப்பட்டவர்களுக்கு, எல்லாவற்றையும் நன்மைக்கு ஏதுவாக நடக்கப்பண்ணுகிறார்.", ref: "ரோமர் 8:28" },
    malayalam: { text: "ദൈവത്തെ സ്നേഹിക്കുന്നവർക്ക്, അതായത് അവന്റെ നിർണ്ണയത്തിൻ പ്രകാരം വിളിക്കപ്പെട്ടവർക്ക്, എല്ലാം നന്മെക്കായി കൂടി വ്യാപരിക്കുന്നു.", ref: "റോമർ 8:28" }
  },
  {
    english: { text: "Jesus said, I am the way and the truth and the life. No one comes to the Father except through me.", ref: "John 14:6" },
    tamil: { text: "இயேசு அவனை நோக்கி: நானே வழியும் சத்தியமும் ஜீவனுமாயிருக்கிறேன்; என்னைத் தவிர வேறொருவனாலும் பிதாவினிடத்தில் வர முடியாது.", ref: "யோவான் 14:6" },
    malayalam: { text: "യേശു അവനോട്: ഞാൻ വഴിയും സത്യവും ജീവനും ആകുന്നു; എന്നിലൂടെ അല്ലാതെ ആരും പിതാവിന്റെ അടുക്കൽ എത്തുന്നില്ല.", ref: "യോഹന്നാൻ 14:6" }
  },
  {
    english: { text: "For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you, plans to give you hope and a future.", ref: "Jeremiah 29:11" },
    tamil: { text: "உங்களுக்கு நான் நினைத்திருக்கிற நினைவுகளை நான் அறிவேன்; அவைகள் தீங்கு செய்யும் நினைவுகளல்ல, நலம் செய்யும் நினைவுகளே.", ref: "எரேமியா 29:11" },
    malayalam: { text: "നിങ്ങൾക്കു ഞാൻ വിചാരിക്കുന്ന വിചാരങ്ങൾ എനിക്കു അറിയാം; ദോഷത്തിനല്ല, നന്മെക്കായിട്ടുള്ള വിചാരങ്ങൾ; നിങ്ങൾക്ക് ഭാവിയും പ്രത്യാശയും കൊടുക്കും.", ref: "യിരെമ്യാവ് 29:11" }
  },
  {
    english: { text: "Come to me, all you who are weary and burdened, and I will give you rest.", ref: "Matthew 11:28" },
    tamil: { text: "வருத்தப்பட்டு பாரஞ்சுமக்கிற எல்லாரும் என்னிடத்தில் வாருங்கள்; நான் உங்களுக்கு இளைப்பாறுதல் தருவேன்.", ref: "மத்தேயு 11:28" },
    malayalam: { text: "അദ്ധ്വാനിക്കുന്നവരും ഭാരം ചുമക്കുന്നവരും ആയ എല്ലാവരும് എന്റെ അടുക്കൽ വരുവിൻ; ഞാൻ നിങ്ങൾക്ക് ആശ്വാസം തരും.", ref: "മത്തായി 11:28" }
  },
  {
    english: { text: "Do not be anxious about anything, but in every situation, by prayer and petition, with thanksgiving, present your requests to God.", ref: "Philippians 4:6" },
    tamil: { text: "எந்த காரியத்திலும் கவலைப்படாதிருங்கள்; எல்லாவற்றிலும் உங்கள் விண்ணப்பங்களை ஸ்தோத்திரத்தோடுகூடிய ஜெபத்தினாலும் வேண்டுதலினாலும் தேவனுக்கு தெரியப்படுத்துங்கள்.", ref: "பிலிப்பியர் 4:6" },
    malayalam: { text: "ഒന്നിനെക്കുറിച്ചും വിചാരപ്പെടരുത്; സർവ്വത്തിലും പ്രാർത്ഥനയാലും അപേക്ഷയാലും സ്തോത്രത്തോടുകൂടെ നിങ്ങളുടെ ആഗ്രഹം ദൈവത്തോട് അറിയിക്കുവിൻ.", ref: "ഫിലിപ്പ്യർ 4:6" }
  },
  {
    english: { text: "The name of the Lord is a fortified tower; the righteous run to it and are safe.", ref: "Proverbs 18:10" },
    tamil: { text: "கர்த்தருடைய நாமம் திடமான கோட்டை; நீதிமான் அதற்குள் ஓடி அடைக்கலம் புகுவான்.", ref: "நீதிமொழிகள் 18:10" },
    malayalam: { text: "യഹോവയുടെ നാമം ഉറപ്പുള്ള ഗോപുരം; നീതിമാൻ അതിലേക്ക് ഓടിക്കയറി സുരക്ഷിതനാകുന്നു.", ref: "സദൃശ്യവാക്യങ്ങൾ 18:10" }
  },
  {
    english: { text: "If my people, who are called by my name, will humble themselves and pray… I will forgive their sin and will heal their land.", ref: "2 Chronicles 7:14" },
    tamil: { text: "என் நாமம் தரிக்கப்பட்ட என் ஜனங்கள் தங்களைத் தாழ்த்தி ஜெபித்து… நான் அவர்கள் பாவத்தை மன்னித்து அவர்கள் தேசத்தை சொஸ்தப்படுத்துவேன்.", ref: "2 நாளாகமம் 7:14" },
    malayalam: { text: "എന്റെ നാമം വഹിക്കുന്ന എന്റെ ജനം തങ്ങളെ താഴ്ത്തി പ്രാർത്ഥിച്ചാൽ… ഞാൻ അവരുടെ പാപം ക്ഷമിച്ച് അവരുടെ ദേശം സൗഖ്യമാക്കും.", ref: "2 ദിനവൃത്താന്തം 7:14" }
  },
  {
    english: { text: "But seek first His kingdom and His righteousness, and all these things will be given to you as well.", ref: "Matthew 6:33" },
    tamil: { text: "முதலில் தேவனுடைய ராஜ்யத்தையும் அவருடைய நீதியையும் தேடுங்கள்; அப்பொழுது இவைகளெல்லாம் உங்களுக்கு கூடக் கொடுக்கப்படும்.", ref: "மத்தேயு 6:33" },
    malayalam: { text: "ദൈവരാജ്യവും അവന്റെ നീതിയും ആദ്യം അന്വേഷിക്കുവിൻ; അതോടൊപ്പം ഇവ ഒക്കെയും നിങ്ങൾക്ക് കൊടുക്കും.", ref: "മത്തായി 6:33" }
  },
  {
    english: { text: "Have I not commanded you? Be strong and courageous. Do not be afraid; do not be discouraged, for the Lord your God is with you.", ref: "Joshua 1:9" },
    tamil: { text: "நான் உனக்கு கட்டளையிடவில்லையோ? திடமனதாயிரு, தைரியமாயிரு; பயப்படாதே, கலங்காதே, உன் தேவனாகிய கர்த்தர் உன்னோடேகூட இருக்கிறார்.", ref: "யோசுவா 1:9" },
    malayalam: { text: "ഞാൻ നിന്നോടു ആജ്ഞാപിച്ചിട്ടില്ലയോ? ശക്തനും ധൈര്യശാലിയും ആയിരിക്ക; ഭ്രമിക്കരുത്, ഭയപ്പെടരുത്; നിന്റെ ദൈവമായ യഹോവ നിന്നോടുകൂടെ ഉണ്ട്.", ref: "യോശുവ 1:9" }
  },
  {
    english: { text: "The Lord is my light and my salvation— whom shall I fear? The Lord is the stronghold of my life— of whom shall I be afraid?", ref: "Psalm 27:1" },
    tamil: { text: "கர்த்தர் என் ஒளியும் என் இரட்சிப்பும்; யாருக்கு பயப்படுவேன்? கர்த்தர் என் ஜீவனின் பெலன்; யாரை அஞ்சுவேன்?", ref: "சங்கீதம் 27:1" },
    malayalam: { text: "യഹോവ എന്റെ പ്രകാശവും എന്റെ രക്ഷയും ആകുന്നു; ഞാൻ ആരെ ഭയപ്പെടും? യഹോവ എന്റെ ജീവന്റെ ബലം; ഞാൻ ആരെ പേടിക്കും?", ref: "സങ്കീർത്തനം 27:1" }
  },
  {
    english: { text: "Cast all your anxiety on Him because He cares for you.", ref: "1 Peter 5:7" },
    tamil: { text: "அவர் உங்களை விசாரிக்கிறவராயிருக்கிறதால், உங்கள் கவலைகளையெல்லாம் அவர்மேல் வைத்துவிடுங்கள்.", ref: "1 பேதுரு 5:7" },
    malayalam: { text: "അവൻ നിങ്ങൾക്കുവേണ്ടി കരുതുന്നതുകൊണ്ട് നിങ്ങളുടെ സകല ചിന്തകളും അവന്റെ മേൽ ഇട്ടേക്കുവിൻ.", ref: "1 പത്രൊസ് 5:7" }
  },
  {
    english: { text: "Give thanks to the Lord, for He is good; His love endures forever.", ref: "Psalm 107:1" },
    tamil: { text: "கர்த்தரை ஸ்தோத்திரியுங்கள், அவர் நல்லவர்; அவருடைய கிருபை என்றென்றும் நிற்கும்.", ref: "சங்கீதம் 107:1" },
    malayalam: { text: "യഹോവ നല്ലവൻ ആകയാൽ അവനെ സ്തുതിക്കുവിൻ; അവന്റെ ദയ എന്നേക്കും ഉള്ളത്.", ref: "സങ്കീർത്തനം 107:1" }
  },
  {
    english: { text: "I am the resurrection and the life. The one who believes in me will live, even though they die.", ref: "John 11:25" },
    tamil: { text: "நானே உயிர்த்தெழுதலும் ஜீவனுமாயிருக்கிறேன்; என்னை விசுவாசிக்கிறவன் மரித்தாலும் பிழைப்பான்.", ref: "யோவான் 11:25" },
    malayalam: { text: "ഞാൻ പുനരുത്ഥാനവും ജീവനുമാകുന്നു; എന്നിൽ വിശ്വസിക്കുന്നവൻ മരിച്ചാലും ജീവിക്കും.", ref: "യോഹന്നാൻ 11:25" }
  },
  {
    english: { text: "Wait on the Lord; be of good courage, and He shall strengthen your heart.", ref: "Psalm 27:14" },
    tamil: { text: "கர்த்தருக்கு காத்திரு; திடமனதாயிரு, அவர் உன் இருதயத்தை பலப்படுத்துவார்.", ref: "சங்கீதம் 27:14" },
    malayalam: { text: "യഹോവക്കായി കാത്തിരിക്ക; ധൈര്യശാലിയായിരിക്ക; അവൻ നിന്റെ ഹൃദയത്തെ ശക്തിപ്പെടുത്തും.", ref: "സങ്കീർത്തനം 27:14" }
  },
  {
    english: { text: "The Spirit of the Lord is on me, because He has anointed me to proclaim good news to the poor.", ref: "Luke 4:18" },
    tamil: { text: "ஏழைகளுக்கு நற்செய்தி அறிவிக்கும்படி ஆண்டவருடைய ஆவி என்மேல் இருக்கிறார்.", ref: "லூக்கா 4:18" },
    malayalam: { text: "ദരിദ്രന്മാർക്ക് സുവിശേഷം അറിയിക്കുവാൻ ദൈവം എന്നെ അഭിഷേകം ചെയ്തതുകൊണ്ട് കർത്താവിന്റെ ആത്മാവ് എന്റെ മേൽ ഉണ്ട്.", ref: "ലൂക്കോസ് 4:18" }
  },
  {
    english: { text: "Your word is a lamp for my feet, a light on my path.", ref: "Psalm 119:105" },
    tamil: { text: "உம்முடைய வார்த்தை என் பாதங்களுக்கு தீபமும், என் பாதையில் வெளிச்சமுமாயிருக்கிறது.", ref: "சங்கீதம் 119:105" },
    malayalam: { text: "നിന്റെ വചനം എന്റെ കാലിന്നു ദീപവും എന്റെ പാതെക്ക് പ്രകാശവും ആകുന്നു.", ref: "സങ്കീർത്തനം 119:105" }
  },
  {
    english: { text: "He gives strength to the weary and increases the power of the weak.", ref: "Isaiah 40:29" },
    tamil: { text: "சோர்ந்தவனுக்கு பலம் கொடுக்கிறார்; சத்துவமில்லாதவனுக்கு வல்லமையைப் பெருகப்பண்ணுகிறார்.", ref: "ஏசாயா 40:29" },
    malayalam: { text: "ക്ഷീണിതർക്ക് അവൻ ശക്തി കൊടുക്കുന്നു; ബലഹീനർക്ക് ബലം വർദ്ധിപ്പിക്കുന്നു.", ref: "യെശയ്യാവ് 40:29" }
  },
  {
    english: { text: "With God all things are possible.", ref: "Matthew 19:26" },
    tamil: { text: "தேவனால் எல்லாம் கூடும்.", ref: "மத்தேயு 19:26" },
    malayalam: { text: "ദൈവത്തിന്നു സകലവും കഴിയും.", ref: "മത്തായി 19:26" }
  },
  {
    english: { text: "The Lord bless you and keep you; the Lord make His face shine on you and be gracious to you.", ref: "Numbers 6:24-25" },
    tamil: { text: "கர்த்தர் உன்னை ஆசீர்வதித்து காத்துக்கொள்வாராக; கர்த்தர் தம்முடைய முகத்தை உன்மேல் பிரகாசிக்கப்பண்ணி உனக்கு கிருபை செய்வாராக.", ref: "எண்ணாகமம் 6:24-25" },
    malayalam: { text: "യഹോവ നിന്നെ അനുഗ്രഹിക്കട്ടെ, നിന്നെ പാലിക്കട്ടെ; യഹോവ തന്റെ മുഖം നിന്റെ മേൽ പ്രകാശിപ്പിക്കട്ടെ, നിന്നോടു കൃപ ചെയ്യട്ടെ.", ref: "സംഖ്യ 6:24-25" }
  },
  {
    english: { text: "Delight yourself in the Lord, and He will give you the desires of your heart.", ref: "Psalm 37:4" },
    tamil: { text: "கர்த்தரில் மனமகிழ்ந்திரு; அவர் உன் இருதயத்தின் வேண்டுதல்களை உனக்கு அருள்வார்.", ref: "சங்கீதம் 37:4" },
    malayalam: { text: "യഹോവയിൽ ആനന്ദിക്ക; അവൻ നിന്റെ ഹൃദയ ആഗ്രഹങ്ങൾ നടത്തിത്തരും.", ref: "സങ്കീർത്തനം 37:4" }
  },
  {
    english: { text: "Greater is He that is in you than he that is in the world.", ref: "1 John 4:4" },
    tamil: { text: "உலகத்திலிருக்கிறவனிலும் உங்களிலிருக்கிறவர் பெரியவர்.", ref: "1 யோவான் 4:4" },
    malayalam: { text: "ലോകത്തിലുള്ളവനെക്കാൾ നിങ്ങളിലുള്ളവൻ വലിയവൻ.", ref: "1 യോഹന്നാൻ 4:4" }
  },
  {
    english: { text: "This is the day the Lord has made; let us rejoice and be glad in it.", ref: "Psalm 118:24" },
    tamil: { text: "இது கர்த்தர் உண்டாக்கின நாள்; இதில் களிகூர்ந்து மகிழ்வோம்.", ref: "சங்கீதம் 118:24" },
    malayalam: { text: "ഇത് യഹോവ ഉണ്ടാക്കിയ ദിവസം; നാം ആനന്ദിച്ചു സന്തോഷിക്കുക.", ref: "സങ്കീർത്തനം 118:24" }
  },
  {
    english: { text: "Blessed are the pure in heart, for they will see God.", ref: "Matthew 5:8" },
    tamil: { text: "இருதயத்தில் சுத்தமுள்ளவர்கள் பாக்கியவான்கள்; அவர்கள் தேவனை தரிசிப்பார்கள்.", ref: "மத்தேயு 5:8" },
    malayalam: { text: "ഹൃദയ ശുദ്ധിയുള്ളവർ ഭാഗ്യവാന്മാർ; അവർ ദൈവത്തെ കാണും.", ref: "മത്തായി 5:8" }
  },
  {
    english: { text: "Let everything that has breath praise the Lord. Praise the Lord.", ref: "Psalm 150:6" },
    tamil: { text: "சுவாசமுள்ள யாவும் கர்த்தரைப் புகழட்டும். அல்லேலூயா.", ref: "சங்கீதம் 150:6" },
    malayalam: { text: "ശ്വാസമുള്ള സകലവും യഹോവയെ സ്തുതിക്കട്ടെ. യഹോവയെ സ്തുതിക്കുവിൻ.", ref: "സങ്കീർത്തനം 150:6" }
  },
  {
    english: { text: "For the word of God is alive and active. Sharper than any double-edged sword.", ref: "Hebrews 4:12" },
    tamil: { text: "தேவனுடைய வார்த்தை ஜீவனும் வல்லமையும் உள்ளது. இருபுறமும் கூர்மையான எந்த பட்டயத்திலும் கூர்மையானது.", ref: "எபிரெயர் 4:12" },
    malayalam: { text: "ദൈവവചനം ജീവനും ചൈതന്യവുമുള്ളതും ഇരുതലവാളിനെക്കാൾ മൂർച്ചയേറിയതും ആകുന്നു.", ref: "എബ്രായർ 4:12" }
  }
];

export function getDailyVerse() {
  const today = new Date();
  const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24));
  return verses[dayOfYear % verses.length];
}

export default verses;
